import { useContext } from "react";
import RecipesContext from "context/RecipeContext";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Recipe from "./Recipe";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 80,
    [theme.breakpoints.down('sm2')]: {
      "& .MuiGrid-grid-xs-12": {
        width: "100%",
        maxWidth: 440,
      },
      "& .MuiGrid-spacing-xs-3": {
        display: "flex",
        justifyContent: "center",
      }
      },
    [theme.breakpoints.up('sm2')]: { 
      "& .MuiGrid-grid-sm-12": {
        maxWidth: "50%",
      },
    },
    "& .MuiPaper-root":{
      padding: 0,
    }
  },
}));

const RecipesContainer = ({ unfilteredRecipes }) => {
  const classes = useStyles();
  const { recipes, isFilterRecipes } = useContext(RecipesContext.context);

  let recipesArray = isFilterRecipes ? [...recipes] : unfilteredRecipes;

  return ( 
    <div className={classes.root}>
      <Grid 
        container 
        spacing={3}
      >
        {recipesArray.map((recipe, index) => (
            <Recipe 
              recipe={recipe} 
              key={index} 
            />
        ))}
      </Grid>
    </div>
  );
}
 
export default RecipesContainer;